import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { ADD_PRODUCTS_ROUTE, ADD_PRODUCTS_SEARCH_ROUTE } from '@mwe/constants';
import { NavigatingBackTo } from '@mwe/models';
import { EnvironmentService, NavigationStateService } from '@mwe/services';
import { TranslateDirective, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonLinkComponent } from '../buttons/button-link/button-link.component';
import { AddStaticImagePathPipe, SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-no-associations-found-warning',
  templateUrl: './no-associations-found-warning.component.html',
  imports: [TranslateDirective, ButtonLinkComponent, TranslatePipe, SafeHtmlPipe, AddStaticImagePathPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAssociationsFoundWarningComponent {
  private router = inject(Router);
  private navigationStateService = inject(NavigationStateService);
  private translateService = inject(TranslateService);
  private environmentService = inject(EnvironmentService);

  noAddressGroupsTitle = input<string>('shared.noAddressGroupsError.title');
  noAddressGroupsText = input<string>();
  navigatingBackTo = input<NavigatingBackTo>();
  productSearchBtnClicked = output<void>();

  private prefixLabel = computed(() => `shared.noAddressGroupsError.productPrefix_${this.environmentService.getPortalCustomerType()}`);
  private prefix = computed(() => this.translateService.instant(this.prefixLabel()));
  translateValues = computed(() => ({ prefix: this.prefix() }));
  titleToUse = computed(() => {
    return this.noAddressGroupsTitle() || 'shared.noAddressGroupsError.title';
  });

  navigateToProductSearch(): void {
    this.productSearchBtnClicked.emit();
    this.navigationStateService.addNavigatingBackTo(this.navigatingBackTo());
    this.router.navigateByUrl(`/${ADD_PRODUCTS_ROUTE}/${ADD_PRODUCTS_SEARCH_ROUTE}`);
  }
}
